





















































































































import { Vue, Component } from 'nuxt-property-decorator';
import InnerImageZoom from 'vue-inner-image-zoom';
import TooltipButton from './TooltipButton.vue';
import CloseBtn from './side-panel/CloseBtn.vue';
import ResponsiveImage from './responsive-image/ResponsiveImage.vue';
import ReadOnlyContent from './ReadOnlyContent.vue';
import { File } from '@/types/contentContract';
import HighslideStore, { HighslideMode } from '@/store/highslide.store';
import VimeoEmbed from '@/components/ui/embeds/VimeoEmbed.vue';

@Component({
  components: {
    ReadOnlyContent,
    VimeoEmbed,
    ResponsiveImage,
    CloseBtn,
    TooltipButton,
    InnerImageZoom
  }
})
export default class Highslide extends Vue {
  isHoveringImage: boolean = false;
  mode = HighslideMode;
  imageToZoom: HTMLImageElement | null = null;

  get overlayActive(): boolean {
    return HighslideStore.highslideActive;
  }

  get mediaLabel(): string {
    return HighslideStore.mediaLabel;
  }

  get highslideMode(): HighslideMode {
    return HighslideStore.highslideMode;
  }

  get wideImageFile(): File | null {
    return HighslideStore.highslideWideImage || null;
  }

  get originalImageFile(): File | null {
    return HighslideStore.originalImage || null;
  }

  get imageMetaDataCaption(): string {
    return HighslideStore.imageMetaDataCaption;
  }

  get embedUrl(): string {
    return HighslideStore.embedUrl;
  }

  get imageCanZoom(): boolean {
    // Prevent zoom on svg images, because the dimensions are weird
    if (this.isSvg) {
      return false;
    }

    if (this.imageToZoom) {
      return (
        this.imageToZoom.height !==
          this.wideImageFile.properties.dimensions.height &&
        this.imageToZoom.width !==
          this.wideImageFile.properties.dimensions.width
      );
    }

    return false;
  }

  get imageFileHasMetaData(): boolean {
    return (
      this.mediaLabel !== '' ||
      this.wideImageFile.properties.description !== null ||
      this.wideImageFile.properties.copyright !== null ||
      this.wideImageFile.properties.credits !== null ||
      this.imageMetaDataCaption !== ''
    );
  }

  get isTransparentImage(): string {
    if (
      this.wideImageFile.publicUrl.endsWith('.png') ||
      this.wideImageFile.publicUrl.endsWith('.svg') ||
      this.wideImageFile.publicUrl.endsWith('.gif')
    ) {
      return 'iiz--is-transparent tw-bg-white';
    }

    return '';
  }

  get isSvg(): boolean {
    return this.wideImageFile.publicUrl.endsWith('.svg');
  }

  mounted() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.isHoveringImage = true;
    }

    if (this.wideImageFile) {
      this.handleIfZoom();
    }
  }

  beforeDestroy() {
    // Remember to reset reference to image
    this.imageToZoom = null;
  }

  async handleIfZoom() {
    this.imageToZoom = await this.getMeta(
      this.wideImageFile.properties.originalUrl
    );
  }

  closeOverlay(): void {
    HighslideStore.closeHighslide();
  }

  wideImageMaxWidth(width: number): string {
    const maxWidth = 1300;

    if (this.wideImageFile.publicUrl.endsWith('svg')) {
      return '90vmax';
    }

    if (this.wideImageFile.publicUrl.endsWith('png')) {
      return '80vmax';
    }

    return width > maxWidth ? `${maxWidth}px` : `${width}px`;
  }

  getZoomImageOriginalUrl(imageUrl: string): string {
    const origin = window.location.origin;
    return `${origin}/${imageUrl}`;
  }

  private getMeta(url: string) {
    return new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject();
      img.src = this.getZoomImageOriginalUrl(url);
    });
  }
}
